import React, { useContext, useEffect, useState } from 'react'
import SunEditor from 'suneditor-react'
import { Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { updateContent, getContent, viewContact, editContact } from '../Network/Content'
import { NotifyContext } from '../Library/Notify'
import { Container, Loading, HeaderTitle } from '../Library'
import { setDocumentTitle } from '../AppTitle'
import 'suneditor/dist/css/suneditor.min.css'
import "./ContactCenter.css"

function ContactCenter() {
    const [isLoading, setLoading] = useState(false)
    const notify = useContext(NotifyContext)
    const contentId = 2
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.content
    const [originalContent, setOriginalContent] = useState("");
    const [content, setContent] = useState("");

    useEffect(()=>{
        setDocumentTitle("Contact Center")
        
        // getContent(contentId, 
        //     (data)=>{
        //         setContent(data.content)
        //         setLoading(false)
        //     },
        //     (error)=>{
        //         notify.showNotify("Something wrong", error.message, 2)
        //         setLoading(false)
        //     })
        const fetchData = () =>{
            setLoading(true)
            viewContact(
                (contact)=>{
                    setContent(contact)
                    setOriginalContent(contact)
                    setLoading(false)
                },
                (error)=>{
                    notify.showNotify("Something wrong", error.message, 2)
                    setLoading(false)
                }
            )
        }

        function closeListener(e){
            e.preventDefault()
            e.returnValue = lang.changed_alert
            return lang.changed_alert
        }

        fetchData()
        window.addEventListener("beforeunload", closeListener)

        return () =>{
            window.removeEventListener("beforeunload", closeListener)
        }
    },[])

    const updateContactCenter = () =>{
        setLoading(true)
        // updateContent(contentId, content,
        //     ()=>{
        //         notify.showNotify(lang.contact_center_success, lang.contact_center_success_desc, 0)
        //         setLoading(false)
        //     },
        //     (error)=>{
        //         notify.showNotify("Something wrong", error.message, 2)
        //         setLoading(false)
        //     })
        editContact(content,
            (contact)=>{
                notify.showNotify(lang.about_us_success, lang.about_us_success_desc, 0)
                setOriginalContent(contact)
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }
   
    return (
        <Container topbarTitle={langCx.lang.sidebar.contact}>
        { isLoading ? <Loading/>: null }
        <div id="contact_center">
            <HeaderTitle 
            title={lang.edit_contact_center}
            customRight={
                <>
                { originalContent !== content ?
                <div className="content-change">
                    <div className="indicator"></div>
                    <span>{lang.content_change}</span>
                </div>
                : null
                }
                </>
            }
            />
             <div className ="editor">
                <SunEditor width="100%" height="450" setOptions={{
                    buttonList: [
                        ['undo', 'redo'],
                        ['font', 'fontSize', 'formatBlock'],
                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                        ['fontColor', 'hiliteColor'],
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                        ['table', 'link'],
                        ['fullScreen', 'showBlocks'],
                    ]
			    }} 
                setContents={content}
                onChange={setContent}
                />
            </div>
            <hr/>
            <Button 
            className="edit-btn" 
            onClick={()=>updateContactCenter()}>
                {lang.save_change}
            </Button>
        </div>
        </Container>
    )
}

export default ContactCenter